import { Spinner } from "block-system/components/Spinner";

export function EmbeddedChatbotFallback() {
  return (
    <span className="absolute inset-0 flex items-end justify-end overflow-hidden p-4">
      <Spinner containerClassName="m-0" size="medium" />
    </span>
  );
}
